<template>
    <div class="container registration-form my-3">

        <modal-verify-email-component v-if="userHash"
                                      :userEmail="userEmail"
                                      :userHash="userHash"></modal-verify-email-component>

        <div class="row justify-content-center">
            <div class="col-md-12">

                <form class="form-register">

                    <h1 class="text-center mb-4">{{ translate.login.register }}</h1>

                    <div class="form-group">
                        <h2 class="heading-xl">{{ translate.login.memberType }}</h2>

                        <!-- User Type -->
                        <div :class="{'has-error': formSubmitted && !$v.memberType.memberTypeEnum}"
                             class="user-types error-input-container">
                            <!-- Escort -->
                            <div id="userType1" :class="{'active': memberType === MemberTypeEnum.ESCORT}"
                                 class="user-type" @click="memberType = MemberTypeEnum.ESCORT">
                                <div class="logo">
                                    <icon-component :icon="fa_person_half_dress()"></icon-component>
                                </div>
                                <div class="title">{{ translate.login.userRegistrationTypes[1] }}</div>
                                {{ translate.login.userRegistrationTypesDescription[1] }}
                            </div>
                            <!-- Punter -->
                            <div id="userType0" :class="{'active': memberType === MemberTypeEnum.PUNTER}"
                                 class="user-type" @click="memberType = MemberTypeEnum.PUNTER">
                                <div class="logo">
                                    <icon-component :icon="fa_child_reaching()"></icon-component>
                                </div>
                                <div class="title">{{ translate.login.userRegistrationTypes[0] }}</div>
                                {{ translate.login.userRegistrationTypesDescription[0][0] }}<br>
                                {{ translate.login.userRegistrationTypesDescription[0][1] }}
                            </div>
                            <!-- Venue -->
                            <div id="userType3" :class="{'active': memberType === MemberTypeEnum.VENUE}"
                                 class="user-type" @click="memberType = MemberTypeEnum.VENUE">
                                <div class="logo">
                                    <icon-component viewBox="250 0 512 512" width="2em"
                                                    :icon="fa_house_person_return()"></icon-component>
                                </div>
                                <div class="title">{{ translate.login.userRegistrationTypes[3] }}</div>
                                {{ translate.login.userRegistrationTypesDescription[3] }}
                            </div>
                            <!-- Manager -->
                            <div id="userType2" :class="{'active': memberType === MemberTypeEnum.MANAGER}"
                                 class="user-type" @click="memberType = MemberTypeEnum.MANAGER">
                                <div class="logo">
                                    <icon-component viewBox="250 0 512 512" width="2em"
                                                    :icon="fa_people_roof()"></icon-component>
                                </div>
                                <div class="title">{{ translate.login.userRegistrationTypes[2] }}</div>
                                {{ translate.login.userRegistrationTypesDescription[2][0] }}<br>
                                {{ translate.login.userRegistrationTypesDescription[2][1] }}
                            </div>
                        </div>
                        <!-- User Type -->

                        <error-component v-if="formSubmitted && $v.memberType.$invalid">
                            {{ translate.login.memberTypeSelect }}
                        </error-component>
                    </div>

                    <h2 class="heading-xl">{{ translate.login.contactInfo }}</h2>

                    <div class="form-group">
                        <live-country-component :post-fix-path="`/users/registration/`"></live-country-component>
                    </div>

                    <div class="form-group">

                        <span class="error-input-container"
                              :class="{'has-error': ($v.emailOrPhone.$error || formSubmitted)
                              && (!$v.emailOrPhone.required || emailTaken)}">

                            <div v-if="memberType === MemberTypeEnum.ESCORT" class="input-group ml-auto">
                                <select id="inputCountryCode"
                                        class="form-control p-1 mr-2"
                                        e2e-id="input-country-code"
                                        v-model.trim="$v.countryCodeId.$model">
                                    <option v-for="country in countryCodes" :value="country.id">
                                        <span>{{ country.emoji }} {{ country.dialCode }}</span>
                                    </option>
                                </select>

                                <input
                                    id="inputEmailOrPhone"
                                    class="form-control pl-2"
                                    :placeholder="translate.login.phonePlaceholder"
                                    e2e-id="input-phone-number"
                                    :type="memberType === MemberTypeEnum.ESCORT ? 'number' : 'text'"
                                    v-model.trim="$v.emailOrPhone.$model"
                                >
                            </div>

                            <input v-else class="form-control"
                                   id="inputEmailOrPhone"
                                   :placeholder="translate.login.emailOrPhone"
                                   type="text"
                                   v-model.trim="$v.emailOrPhone.$model">
                        </span>

                        <span v-if="$v.emailOrPhone.$error || formSubmitted">
                            <error-component v-if="!$v.emailOrPhone.required"
                                             :message="memberType === MemberTypeEnum.ESCORT ? translate.login.phoneRequired : translate.login.emailRequired"></error-component>

                            <error-component :message="translate.login.emailNotValid"
                                             v-if="emailNotValid"></error-component>
                            <error-component :message="translate.login.phoneNotValid"
                                             v-if="phoneNotValid"></error-component>

                            <error-component :message="translate.login.emailOrPhoneTaken" v-if="emailOrPhoneTaken">
                                <a :href="regionRelativeUrl('/users/forgot-password/')">{{
                                        translate.login.emailOrPhoneTaken2
                                    }}</a>{{ translate.login.emailOrPhoneTaken3 }}
                            </error-component>
                        </span>

                        <span v-if="memberType === MemberTypeEnum.ESCORT && ($v.countryCodeId.$error || formSubmitted)">
                            <error-component v-if="!$v.countryCodeId.required"
                                             :message="translate.login.countryDialCodeRequired"></error-component>
                        </span>

                    </div>

                    <div class="form-group">

                        <span class="error-input-container"
                              :class="{'has-error': ($v.username.$error || formSubmitted)
                              && (!$v.username.required || usernameTaken)}">
                            <input class="form-control" id="inputUsername" :placeholder="translate.login.username"
                                   type="text"
                                   v-model.trim="$v.username.$model">
                        </span>

                        <span v-if="$v.username.$error || formSubmitted">
                            <error-component :message="translate.login.usernameRequired"
                                             v-if="!$v.username.required"></error-component>
                            <error-component :message="translate.login.usernameTaken"
                                             v-if="usernameTaken"></error-component>
                        </span>

                        <div class="username-suggestions">
                            <a href="#" v-for="(username, i) in suggestedUsernames"
                               class="suggested-username" @click.prevent="applySuggestedUsername(username)"
                               :key="i">{{ username }}</a>
                        </div>


                    </div>

                    <div class="form-group">

                        <span class="error-input-container"
                              :class="{'has-error': ($v.password.$error || formSubmitted)
                              && !$v.password.required}">
                            <input class="form-control" id="inputPassword" :placeholder="translate.login.password"
                                   type="password"
                                   v-model.trim="$v.password.$model">
                        </span>

                        <span v-if="$v.password.$error || formSubmitted">

                            <error-component :message="translate.login.passwordRequired"
                                             v-if="!$v.password.required"></error-component>

                        </span>

                    </div>

                    <div class="form-group">

                        <span class="error-input-container"
                              :class="{'has-error': ($v.passwordConfirm.$error || formSubmitted)
                              && (!$v.passwordConfirm.required || !$v.passwordConfirm.sameAsPassword)}">
                            <input class="form-control" id="inputPasswordConfirm"
                                   :placeholder="translate.login.confirmPassword"
                                   type="password" v-model.trim="$v.passwordConfirm.$model">
                        </span>

                        <span v-if="$v.passwordConfirm.$error || formSubmitted">

                            <error-component :message="translate.login.passwordRepeat"
                                             v-if="!$v.passwordConfirm.required"></error-component>
                            <error-component :message="translate.login.passwordDontMatch"
                                             v-if="!$v.passwordConfirm.sameAsPassword"></error-component>

                        </span>

                    </div>

                    <div class="form-group" v-if="captcha && captcha.img">

                        <span class="error-input-container"
                              :class="{'has-error': ($v.captchaInput.$error || formSubmitted) && (!$v.captchaInput.required || captchaNotValid && !captchaInput)}">
                            <img :src="captcha.img" class="w-100">
                            <input class="form-control" v-model.trim="$v.captchaInput.$model"
                                   id="captchaInput" type="text" :placeholder="translate.login.enterCaptchaPlaceholder">
                        </span>

                        <span v-if="$v.captchaInput.$error || formSubmitted">
                            <error-component :message="translate.login.enterCaptchaErrorWrong"
                                             v-if="captchaNotValid && !captchaInput"></error-component>
                            <error-component :message="translate.login.enterCaptchaErrorRequired"
                                             v-else-if="!$v.captchaInput.required"></error-component>
                        </span>

                    </div>


                    <div class="from-check">

                        <div class="form-check form-check--align-right">
                            <input class="form-check-input" id="inputAcceptTerms" type="checkbox"
                                   v-model="$v.acceptTerms.$model">
                            <label class="form-check-label" for="inputAcceptTerms">{{ translate.login.iAcceptTerm1 }}
                                <a target="_blank" href="/agb/">{{ translate.login.iAcceptTerm2 }}</a>
                            </label>
                        </div>

                        <span v-if="formSubmitted">
                            <error-component :message="translate.login.readAndAccept"
                                             v-if="!$v.acceptTerms.required"></error-component>
                        </span>

                    </div>

                    <button-with-loading-component class="btn btn-primary btn-block mt-5"
                                                   type="submit"
                                                   :text="translate.login.register"
                                                   :loading="loading"
                                                   @click.native.prevent="onSubmit"
                    ></button-with-loading-component>


                </form>
            </div>
        </div>
    </div>
</template>

<script>
import {validationMixin} from 'vuelidate';
import {required, sameAs} from 'vuelidate/lib/validators';
import userRegistrationMixin from "@/components/mixins/userRegistrationMixin";
import ButtonWithLoadingComponent from "@/components/global/ButtonWithLoadingComponent";
import {fa_child_reaching, fa_house_person_return, fa_people_roof, fa_person_half_dress} from "@/core/constants/icons";
import IconComponent from "@/components/global/IconComponent.vue";
import countryCodeMixin from "@/components/mixins/countryCodeMixin";
import {MemberTypeEnum} from "@/core/constants/enums/memberTypeEnum";
import {LocaleEnum} from "@/core/constants/enums/localeEnum";
import LiveCountryComponent from "@/components/partials/LiveCountryComponent.vue";
import {regionRelativeUrl} from "@/core/utils/helpers/regions/regionUrlHelper";

const data = () => ({
    store: $store,
    captcha: {},
    captchaInput: null,
    captchaNotValid: false,
    isCountryCodeChosen: false,
    MemberTypeEnum,
    LocaleEnum,
});

async function created() {
    this.getCaptcha()

    this.countryCodeId = await this.fetchCountryCodes()
}

async function submitForm() {
    this.loading = true;

    if (this.memberType === MemberTypeEnum.ESCORT) {
        this.emailOrPhone = this.prepareEscortsEmailOrPhoneNumberForPayload();
    }

    const payload = {
        emailOrPhone: this.emailOrPhone,
        username: this.username,
        password: this.password,
        repeat_password: this.passwordConfirm,
        user_role: this.memberType,
        accept_terms: this.acceptTerms,
        valid_age: this.validAge,
    };

    if (this.memberType === MemberTypeEnum.ESCORT) {
        payload.dialCode = this.dialCode;
    }

    if (_.get(this, 'captcha.img')) {
        payload.captcha = this.captchaInput;
        payload.captchaKey = this.captcha.key;
    }

    const [err, response] = await to(
        api.auth.register(payload)
    );

    if (err) {
        this.onFailure(_.get(err, "response.data", undefined));
        this.getCaptcha();
    }

    if (_.get(response, 'data.success', false)) {
        this.onSuccess(response);
    }

    if (_.get(response, 'data.whatsapp', false)) {
        return this.onVerifyWhatsapp(_.get(response, 'data.user'));
    }

    if (_.get(response, 'data.verifyNumber', false)) {
        this.onVerifyNumber(_.get(response, 'data.user'));
    }
}

function prepareEscortsEmailOrPhoneNumberForPayload() {
    /** trim leading zeros **/
    const phoneNumberWithoutLeadingZeros = _.trimStart(this.emailOrPhone, '0+');
    /** we take only numbers form dial code without plus sign */
    const dialCodeWithoutExtraCharacters = this.dialCode.replace(/^\D+/g, '');
    const phoneNumberWithoutCountryDialCode = phoneNumberWithoutLeadingZeros.replace(new RegExp(`^${dialCodeWithoutExtraCharacters}`), '')

    /** remove country dial code form phone field if it's already provided */
    const phoneNumber = phoneNumberWithoutCountryDialCode.replace(this.dialCode, '');

    return `${this.dialCode}${phoneNumber}`;
}

function onVerifyNumber(userId) {
    this.registrationSuccess = true;
    window.location.href = regionRelativeUrl('/user/verify-number/' + userId);
}

function onVerifyWhatsapp(userId) {
    this.registrationSuccess = true;

    window.location.href = regionRelativeUrl('/user/verify-number/whatsapp/' + userId);
}

function onSuccess(response) {
    this.registrationSuccess = true;
    this.userHash = _.get(response, 'data.userHash', null);
    this.userEmail = _.get(response, 'data.userEmail', null);

    const redirect = _.get(response, 'data.redirect');
    if (redirect) {
        window.location.href = regionRelativeUrl(redirect);
    }
}

async function getCaptcha() {
    this.captchaInput = null;

    const [err, response] = await to(
        api.captcha.registration()
    )

    if (err) {
        toastr.error(this.translate.home.errorCommon);
    }

    this.captcha = _.get(response, 'data', {});
}

export default {
    data,
    created,
    components: {
        LiveCountryComponent,
        IconComponent,
        ButtonWithLoadingComponent,
    },
    mixins: [
        validationMixin,
        userRegistrationMixin,
        countryCodeMixin,
    ],
    validations: {
        countryCodeId: {
            required,
        },
        emailOrPhone: {
            required,
        },
        username: {
            required
        },
        password: {
            required,
        },
        passwordConfirm: {
            required,
            sameAsPassword: sameAs('password')
        },
        memberType: {
            required,
            memberTypeEnum: (value) => Object.values(MemberTypeEnum).includes(value),
        },
        acceptTerms: {
            required: (value) => value === true
        },
        captchaInput: {
            required: function (value) {
                return !_.get(this, 'captcha.img', false) || (_.get(value, 'length', -1) > 0)
            }
        },
    },
    methods: {
        fa_house_person_return,
        fa_child_reaching,
        fa_people_roof,
        fa_person_half_dress,
        submitForm,
        onSuccess,
        onVerifyNumber,
        onVerifyWhatsapp,
        getCaptcha,
        prepareEscortsEmailOrPhoneNumberForPayload,
        regionRelativeUrl
    },
    computed: {
        ...mapState([
            'translate'
        ]),
        dialCode() {
            return this.countryCodes
                .find(countryDialCode => countryDialCode.id === this.$v.countryCodeId.$model)
                .dialCode
        }
    },
};
</script>
